import React from "react";
import HeaderImage from "../assets/bank-assets/header.png";
import { useTranslation } from "react-i18next";

function Politiques() {
  const { t, i18n } = useTranslation();

  return (
    <>
      {i18n.language === "fr" ? (
        <div className="flex flex-col items-center w-screen px-4 lg:px-12" dir="ltr">
          <div className="justify-center my-10 text-center">
            <h2 className="text-4xl text-primary-color font-extrabold mb-6">
              Politique de confidentialité
            </h2>
            <img alt="Header" className="w-128 rounded-xl shadow-md" src={HeaderImage} />
          </div>
          <div className="max-w-4xl text-left bg-gray-50 rounded-lg p-8 shadow-sm">
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Objet :</h3>
            <p className="text-gray-700 leading-relaxed">Cette politique vise à fournir des informations claires sur la manière dont SPA CONDOR ELECTRONICS traite vos données personnelles, en conformité avec la loi 18-07 relative à la protection des données à caractère personnel pour le traitement (E-Faciliti) déclaré à l’ANPDP.
              <br />
              Elle détaille également vos droits et les modalités pour les exercer. Nous nous engageons à garantir la confidentialité de vos données et à sécuriser vos interactions avec nos services. Veuillez lire attentivement ce document pour comprendre le traitement de vos données.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">Définition des données personnelles :</h3>
            <p className="text-gray-700 leading-relaxed">Les données personnelles désignent toute information concernant une personne physique permettant son identification directe ou indirecte, telles que le nom, prénom, adresse, adresse e-mail, identifiant utilisateur, adresse IP, etc.</p>
            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">Responsable du traitement :</h3>
            <p className="text-gray-700 leading-relaxed">SPA CONDOR ELECTRONICS, immatriculée au CNRC sous le numéro 34/00-0462772 B02 et ayant son siège social La Zone d’Activités, Rte M’sila Ilot 70, Section 161, Bordj bou arreridj Algérie 34000, est responsable du traitement des données collectées dans le cadre du traitement E-Faciliti.</p>
            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">Catégories de données collectées et durée de conservation :</h3>
            <p className="text-gray-700 leading-relaxed">
              Les catégories de personne dont SPA CONDOR ELECTRONICS, collecte des données à caractère personnelle sont :
              Prospect pour l'achat facilité.<br />

              SPA CONDOR ELECTRONICS, collecte et traite différentes catégories de données personnelles. Les catégories de données collectées et leur durée de conservation sont les suivantes :
            </p>
            <table className="min-w-full border-collapse border border-gray-200 mt-6">
              <thead className="bg-gray-100">
                <tr className="bg-gray-100">
                  <th className="border border-gray-200 px-4 py-2 text-left font-semibold text-gray-700">Catégorie</th>
                  <th className="border border-gray-200 px-4 py-2 text-left font-semibold text-gray-700">Type</th>
                  <th className="border border-gray-200 px-4 py-2 text-left font-semibold text-gray-700">Durée de conservation (mois)</th>
                </tr>
              </thead>
              <tbody className="bg-white">
                <tr>
                  <td className="border border-gray-200 px-4 py-2 font-semibold text-gray-700">Données personnelles <br /> بيانات شخصية</td>
                  <td className="border border-gray-200 px-4 py-2 text-gray-700">
                    <ul className="list-disc ml-4">
                      <li>Nom et Prénom ..... اللقب والاسم</li>
                      <li>Adresse du domicile ..... عنوان السكن</li>
                      <li>Adresse Mail ..... البريد الإلكتروني</li>
                      <li>Nº de téléphone ..... رقم الهاتف</li>
                    </ul>
                  </td>
                  <td className="border border-gray-200 px-4 py-2 text-center text-gray-700">24</td>
                </tr>
              </tbody>
            </table>

            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">Finalités du traitement :</h3>
            <p className="text-gray-700 leading-relaxed">
              SPA CONDOR ELECTRONICS traite vos données personnelles pour les finalités suivantes :
            </p>
            <table className="min-w-full border-collapse border border-gray-200 mt-6">
              <thead className="bg-gray-100">
                <tr className="bg-gray-100">
                  <th className="border border-gray-200 px-4 py-2 text-left font-semibold text-gray-700">Finalité</th>
                  <th className="border border-gray-200 px-4 py-2 text-left font-semibold text-gray-700">Base légale</th>

                </tr>
              </thead>
              <tbody className="bg-white">
                <tr>
                  <td className="border border-gray-200 px-4 py-2 text-gray-700">Répondre à votre requête sur le formulaire de contact</td>
                  <td className="border border-gray-200 px-4 py-2 text-gray-700">Le consentement exprès de la personne concernée.</td>
                  {/* <td className="border border-gray-200 px-4 py-2 text-gray-700"></td> */}
                </tr>
                <tr>
                  <td className="border border-gray-200 px-4 py-2 text-gray-700">Générer une pro-forma</td>
                  <td className="border border-gray-200 px-4 py-2 text-gray-700">L'exécution d'un contrat ou précontrat à la demande de la personne.</td>
                  {/* <td className="border border-gray-200 px-4 py-2 text-gray-700"></td> */}
                </tr>
                <tr>
                  <td className="border border-gray-200 px-4 py-2 text-gray-700">Vous envoyer notre newsletter, des offres et des promotions</td>
                  <td className="border border-gray-200 px-4 py-2 text-gray-700">Le consentement exprès de la personne concernée.</td>
                  {/* <td className="border border-gray-200 px-4 py-2 text-gray-700"></td> */}
                </tr>
                <tr>
                  <td className="border border-gray-200 px-4 py-2 text-gray-700">Produire des Rapports et statistiques</td>
                  <td className="border border-gray-200 px-4 py-2 text-gray-700">La réalisation d'un intérêt légitime poursuivi par le responsable du traitement.</td>
                  {/* <td className="border border-gray-200 px-4 py-2 text-gray-700"></td> */}
                </tr>
              </tbody>
            </table>

            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">Destinataires des données :</h3>
            <p className="text-gray-700 leading-relaxed">SPA CONDOR ELECTRONICS met en œuvre des procédures strictes pour garantir que seules les personnes autorisées ont accès aux données collectées. Les destinataires potentiels incluent <br />
              Nous ne partagerons pas vos informations personnelles avec des tiers sans votre consentement, et sauf si cela est nécessaire pour répondre à vos demandes ou dans le cadre d’une obligation réglementaire.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">Sécurité des données :</h3>
            <p className="text-gray-700 leading-relaxed">
              SPA CONDOR ELECTRONICS applique des mesures techniques et organisationnelles adéquates pour sécuriser les données personnelles contre tout accès non autorisé, toute divulgation, toute altération ou toute perte, Ces mesures incluent : <br />
              DATACENTER, Politique de Sauvgarde des Données, Sécurité d'acces Physique aux Locaux, Documentation des Procédures de Sécurité, Traçabilité d'acces aux Données, Disaster Recovery (backup), Système de Télésurveillance.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">Vos Droits :</h3>
            <p className="text-gray-700 leading-relaxed">
              En vertu des articles 34 à 36 de la loi 18-07, vous disposez des droits suivant :
            </p>
            <ul className="list-disc ml-4">
              <li>Droit d’accès.</li>
              <li>Droit de rectifications.</li>
              <li>Droit d’opposition.</li>
            </ul>
            Pour exercer vos droits, vous pouvez contacter SPA CONDOR ELECTRONICS en envoyant un email à dpo@condor.dz
      
          <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">Modifications de la Politique de confidentialité :</h3>
          <p className="text-gray-700 leading-relaxed">SPA CONDOR ELECTRONICS se réserve le droit de modifier cette Politique de confidentialité à tout moment. La version la plus récente est disponible à l’adresse https://politique-confidentialite.</p>
          <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">Contact :</h3>
          <p className="text-gray-700 leading-relaxed">
            Pour toute question ou préoccupation concernant cette Politique de confidentialité, veuillez contacter SPA CONDOR ELECTRONICS à l’adresse e-mail : dpo@condor.dz.
          </p>
        </div>
        </div >
      )
        : (












































    <div className="flex flex-col items-center w-screen px-4 lg:px-12" dir="rtl">
      <div className="justify-center my-10 text-center">
        <h2 className="text-4xl text-primary-color font-extrabold mb-6" >
          سياسة الخصوصية
        </h2>
        <img alt="Header" className="w-128 rounded-xl shadow-md" src={HeaderImage} />
      </div>
      <div className="max-w-4xl text-right bg-gray-50 rounded-lg p-8 shadow-sm">
        <h3 className="text-xl font-semibold text-gray-800 mb-2" dir="ltr">:موضوع </h3>
        <p className="text-gray-700 leading-relaxed">
        الهدف من هذه السياسة هو تقديم معلومات واضحة حول كيفية معالجة شركة SPA CONDOR ELECTRONICS لبياناتك الشخصية، وفقًا للقانون 18-07 بشأن حماية البيانات الشخصية للمعالجة (E-Faciliti) المُعلن عنه لدى الوكالة الوطنية لحماية البيانات الشخصية.
        </p>
        <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2" dir="ltr">:تعريف البيانات الشخصية </h3>

        <p className="text-gray-700 leading-relaxed">البيانات الشخصية هي أي معلومات عن شخص طبيعي تُمكِّن من تحديد هويته بشكل مباشر أو غير مباشر، مثل اللقب والاسم الأول والعنوان وعنوان البريد الإلكتروني وعنوان البريد الإلكتروني ومُعرِّف المستخدم وعنوان IP، إلخ. </p>
        <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2" dir="ltr">:مسؤول المعالجة </h3>
        <p className="text-gray-700 leading-relaxed">شركة SPA CONDOR ELECTRONICS، المسجلة لدى CNRC تحت رقم 34/00-0462772 B02 ومكتبها المسجل في La Zone d'Activités، Rte M'sila Ilot 70، قسم 161، برج بوعريريج الجزائر 34000، هي المسؤولة عن معالجة البيانات التي تم جمعها كجزء من معالجة E-Faciliti.</p>
        <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2" dir="ltr">:فئات البيانات التي يتم جمعها ومدة الاحتفاظ بها </h3>
        <p className="text-gray-700 leading-relaxed">
          فئات الأشخاص الذين تجمع SPA CONDOR ELECTRONICS بياناتهم الشخصية هي<br />
          <ul className="list-disc ml-4">
            <li>العملاء المحتملين للشراء الميسر.</li>
          </ul>

          تقوم شركة SPA CONDOR ELECTRONICS بجمع ومعالجة فئات مختلفة من البيانات الشخصية. فيما يلي فئات البيانات التي يتم جمعها وفترات الاحتفاظ بها:</p>
        <table className="min-w-full border-collapse border border-gray-200 mt-6">
          <thead className="bg-gray-100">
            <tr className="bg-gray-100">
              <th className="border border-gray-200 px-4 py-2 text-right font-semibold text-gray-700">الفئة</th>
              <th className="border border-gray-200 px-4 py-2 text-right font-semibold text-gray-700">النوع</th>
              <th className="border border-gray-200 px-4 py-2 text-right font-semibold text-gray-700">مدة الحفظ (بالأشهر)</th>
            </tr>
          </thead>
          <tbody className="bg-white">
            <tr>
              <td className="border border-gray-200 px-4 py-2 font-semibold text-gray-700">البيانات الشخصية <br /> Données personnelles</td>
              <td className="border border-gray-200 px-4 py-2 text-gray-700">
                <ul className="list-disc mr-4">
                  <li>الاسم واللقب ..... Nom et Prénom</li>
                  <li>عنوان السكن ..... Adresse du domicile</li>
                  <li>البريد الإلكتروني ..... Adresse Mail</li>
                  <li>رقم الهاتف ..... Nº de téléphone</li>
                </ul>
              </td>
              <td className="border border-gray-200 px-4 py-2 text-center text-gray-700">24</td>
            </tr>
          </tbody>
        </table>

        <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2" dir="ltr">:أغراض المعالجة </h3>
        <p className="text-gray-700 leading-relaxed">
        تعالج شركة SPA CONDOR ELECTRONICS بياناتك الشخصية للأغراض التالية:</p>
        <table className="min-w-full border-collapse border border-gray-200 mt-6">
          <thead className="bg-gray-100">
            <tr className="bg-gray-100">
              <th className="border border-gray-200 px-4 py-2 text-right font-semibold text-gray-700">الغرض</th>
              <th className="border border-gray-200 px-4 py-2 text-right font-semibold text-gray-700">الأساس القانوني</th>
              {/* <th className="border border-gray-200 px-4 py-2 text-right font-semibold text-gray-700">مزيد من التفاصيل</th> */}
            </tr>
          </thead>
          <tbody className="bg-white">
            <tr>
              <td className="border border-gray-200 px-4 py-2 text-gray-700">الرد على طلبك في نموذج الاتصال</td>
              <td className="border border-gray-200 px-4 py-2 text-gray-700">الموافقة الصريحة للشخص المعني.</td>
              {/* <td className="border border-gray-200 px-4 py-2 text-gray-700"></td> */}
            </tr>
            <tr>
              <td className="border border-gray-200 px-4 py-2 text-gray-700">إنشاء فاتورة أولية</td>
              <td className="border border-gray-200 px-4 py-2 text-gray-700">تنفيذ عقد أو عقد ما قبل العقد بناءً على طلب الشخص.</td>
              {/* <td className="border border-gray-200 px-4 py-2 text-gray-700"></td> */}
            </tr>
            <tr>
              <td className="border border-gray-200 px-4 py-2 text-gray-700">إرسال النشرة الإخبارية والعروض والعروض الترويجية إليك</td>
              <td className="border border-gray-200 px-4 py-2 text-gray-700">الموافقة الصريحة للشخص المعني.</td>
              {/* <td className="border border-gray-200 px-4 py-2 text-gray-700"></td> */}
            </tr>
            <tr>
              <td className="border border-gray-200 px-4 py-2 text-gray-700">إنتاج التقارير والإحصائيات</td>
              <td className="border border-gray-200 px-4 py-2 text-gray-700">تحقيق مصلحة مشروعة يسعى إليها مسؤول المعالجة.</td>
              {/* <td className="border border-gray-200 px-4 py-2 text-gray-700"></td> */}
            </tr>
          </tbody>
        </table>

        <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2" dir="ltr">:متلقو البيانات </h3>
        <p className="text-gray-700 leading-relaxed">تطبق شركة SPA CONDOR ELECTRONICS إجراءات صارمة لضمان وصول الأشخاص المصرح لهم فقط إلى البيانات التي تم جمعها. يشمل المستلمون المحتملون ما يلي  </p>
        <table className="min-w-full border-collapse border border-gray-200 mt-6">
          <thead className="bg-gray-100">
            <tr className="bg-gray-100">
              <th className="border border-gray-200 px-4 py-2 text-right font-semibold text-gray-700">المستلم</th>
              <th className="border border-gray-200 px-4 py-2 text-right font-semibold text-gray-700">وسائل الاتصال</th>
              
            </tr>
            <tr className="bg-white">
            <td className="border border-gray-200 px-4 py-2 text-gray-700">الهيئات التنظيمية</td>
            <td className="border border-gray-200 px-4 py-2 text-gray-700">الورق وتكنولوجيا المعلومات</td>
             
            </tr>
          </thead>
        </table>
        <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2" dir="ltr">:أمن البيانات </h3>
        <p className="text-gray-700 leading-relaxed">
        تطبق شركة SPA CONDOR ELECTRONICS تدابير تقنية وتنظيمية ملائمة لتأمين البيانات الشخصية ضد الوصول غير المصرح به أو الإفصاح عنها أو تغييرها أو فقدانها، وتشمل هذه التدابير: <br/>
        مركز البيانات، وسياسة النسخ الاحتياطي للبيانات، وتأمين الوصول المادي إلى المباني، وتوثيق الإجراءات الأمنية، وتتبع الوصول إلى البيانات، والتعافي من الكوارث (النسخ الاحتياطي)، ونظام المراقبة عن بُعد. </p>
       

        <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2" dir="ltr">:حقوقك </h3>
        <p className="text-gray-700 leading-relaxed">
          بموجب المواد من 34 إلى 36 من القانون 18-07، لديك الحقوق التالية<br />
          •	حق الوصول.<br />
          •	حق التصحيح.<br />
          •	حق الاعتراض.<br />
          لممارسة حقوقك، يمكنك الاتصال بـ SPA CONDOR ELECTRONICS عن طريق إرسال بريد إلكتروني إلى dpo@condor.dz
        </p>
        <div dir="rtl">
          <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2" dir="ltr">:تعديلات على سياسة الخصوصية</h3>
          <p className="text-gray-700 leading-relaxed">
            تحتفظ SPA CONDOR ELECTRONICS بالحق في تعديل سياسة الخصوصية هذه في أي وقت. أحدث نسخة متاحة على العنوان
            <a href="https://politique-confidentialite.dp-manager.com/?folder=condor&trt=18" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
              https://politique-confidentialite
            </a>.
          </p>

          <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2" dir="ltr">:الاتصال</h3>
          <p className="text-gray-700 leading-relaxed">
            لأية أسئلة أو مخاوف بشأن سياسة الخصوصية هذه، يرجى الاتصال بـ SPA CONDOR ELECTRONICS على عنوان البريد الإلكتروني:
            <a href="mailto:dpo@condor.dz" className="text-blue-600 hover:underline">
              dpo@condor.dz
            </a>.
          </p>
        </div>
      </div>
    </div>
  )
}
    </>
  );
}

export default Politiques;
